import BookItem from "../common/bookItem";
import MapToggleChild from "./map_toggle_child";
import MapToggleSwitchChild from "./map_toggle_switch_child";
import { mouseEvent } from "../common/mouse_event";
//報廢中
export default class MapToggle extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.isUsed = false;
        this.openAns = false;
        this.connectNumber = this.el.connectNumber;

        this.storeGroup = [];
        this.storeConnect = [];
    }

    //A檔社會done

    init() {
        super.init();
        this.target.gotoAndStop(0);
        mouseEvent.add_mouse_event(this);

        this.itemControl.bookItems.forEach(element => {
            if ((element instanceof MapToggleChild)) {
                this.storeGroup.push(element);

                if (element.connectNumber == this.connectNumber) {
                    this.storeConnect.push(element);
                }

            }
        });

    }

    trigger() {
        const self = this;
        // this.storeConnect[0].target.visible = true;
        //關
        this.storeGroup.forEach(element => {
            element.target.visible = false;
        });

        //上下一個關
        self.itemControl.bookItems.forEach(element => {
            if ((element instanceof MapToggleSwitchChild)) {
                element.target.visible = false;
            }
        });


        //開
        this.storeConnect[0].target.visible = true;

        //初始化影格
        this.storeConnect[0].target.gotoAndStop(0);
        this.storeConnect[0].itemControl.loader.singleAntialiasing(this.storeConnect[0].target);


        // 如有多圖切，開上一個下一個物件
        if (this.storeConnect[0].target.totalFrames != 1) {
            self.itemControl.bookItems.forEach(element => {
                if ((element instanceof MapToggleSwitchChild) && element.connectNumber == self.connectNumber) {
                    if (element.ctrlObjStep == "下一個") {
                        element.target.visible = true;
                    }
                }
            });
        }
    }
}